import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Popover
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {

      data: {
        id: '',
				name: '',
				ano: '',
				areaHA: '',
				fase: {name: ''},
				idCode: '',
				numero: '',
				processo: '',
				substancia: {name: ''},
				evento: {name: ''},
        substanciaUso: {name: ''},
        uf: '',
				color: '#87CEFA',
        colorRGB: {r: 135, g: 206, b: 250, a: 1},
				status: "ATIVO",
				deleted: false,
				createdAt: '',
        updatedAt: '',
        cidadeList: []
      }
    };
  }

  loadData(selected) {
    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {
        this.setState({ 
          data: selected
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected } = this.props;
    this.loadData(selected);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected){
      this.loadData(this.props.selected);
    }
  }

  componentWillUnmount() {
  }

  clear(){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['ano'] = '';
    data['areaHA'] = '';
    data['fase'] = {name: ''};
    data['idCode'] = '';
    data['numero'] = '';
    data['processo'] = '';
    data['substancia'] = {name: ''};
    data['evento'] = {name: ''};
    data['substanciaUso'] = {name: ''};
    data['uf'] = '';
    data['color'] = '#87CEFA';
    data['colorRGB'] = {r: 135, g: 206, b: 250, a: 1};
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';

    this.setState({ 
      data
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  render() {
    const { t } = this.props;

    let uf = "";
    if(this.state.data.uf !== null && this.state.data.uf.length > 0){
      uf = this.state.data.uf.toUpperCase();
    }

    let cidades = [];
    for(let i = 0; i < this.state.data.cidadeList.length; i++){
      cidades.push(<div key={"cidade_"+i}>{this.state.data.cidadeList[i]}</div>);
    }
    let isDivisa = false;
    if(cidades.length > 1){
      isDivisa = true;
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <style>{`
              input[readOnly] {
                background-color: #f2f4f7;
                opacity: .8;
              }
            `}
            </style>
            <div className="form">

              <div className="form__half">
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.processo')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="processo"
                      value={this.state.data.processo}
                      readOnly={true}
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.numero')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="numero"
                      value={this.state.data.numero}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.code')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="idCode"
                      value={this.state.data.idCode}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.fase')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="fase"
                      value={this.state.data.fase.name}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.substancia')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="substancia"
                      value={this.state.data.substancia.name}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.uf')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="uf"
                      value={uf}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>


              <div className="form__half">
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.name')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="name"
                      value={this.state.data.name}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.ano')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="ano"
                      value={this.state.data.ano}
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.areaHA')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="areaHA"
                      value={this.state.data.areaHA}
                      readOnly={true}
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.evento')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="evento"
                      value={this.state.data.evento.name}
                      readOnly={true}
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.substanciaUso')}
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="substanciaUso"
                      value={this.state.data.substanciaUso.name}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>


              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.localizacao')} <i style={{color: '#ff0000', fontSize: '11px'}}>{(isDivisa ? t('forms.localizacaoDivisa') : '')} </i> 
                </span>
                <div className="form__form-group-field" 
                  style={{borderLeft: '2px solid #ffd9d9', minHeinght: '25px', height: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', paddingLeft: '5px',
                          marginLeft: '5px', fontStyle: 'italic', color: '#ff0000'}}>
                  {cidades}

                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button type="button" onClick={e => this.cancel(e)}>
                  {t('forms.voltar')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'requerimentoEdit', 
})(withTranslation('common')(CrudEdit));
